import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { EquipsTableAxios } from "../components/Tables/EquipmentsTable";

function Equipments() {
  const { titleEquipsString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleEquipsString}</title>
      </Helmet>
      <div className="datatable">
        <EquipsTableAxios />
      </div>
    </div>
  );
}

export default Equipments;
